import {emptyValidator, formValidator, mobilePhoneMenValidator} from "../../validators";

const deviceRegisterFormValidationStatus ={
    regMobile: {
        validators: [mobilePhoneMenValidator()],
        name: "Mobile",
    },
    regUser: {
        validators: [emptyValidator()],
        name: "User",
    },
    regAlertType: {
        validators: [emptyValidator()],
        name: "Notification Type",
    },
};
export const deviceRegisterFormValidation = (mobileNumber) => {
    return formValidator(mobileNumber, deviceRegisterFormValidationStatus);
};

const deviceBulkRegisterValidationStatus ={

    dbrAlertType: {
        validators: [emptyValidator()],
        name: "Notification Type",
    },

    dbrStakeholder: {
        validators: [emptyValidator()],
        name: "Stakeholder ",
    },
};
export const deviceBulkRegisterValidation = (mobileNumber) => {
    return formValidator(mobileNumber, deviceBulkRegisterValidationStatus);
};
